// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from 'E:/jenkins/jenkins_home/workspace/prod_ragflow_web/apps/web/src/models/qiankunState';
import model_2 from 'E:/jenkins/jenkins_home/workspace/prod_ragflow_web/apps/web/src/models/system';
import model_3 from 'E:/jenkins/jenkins_home/workspace/prod_ragflow_web/apps/web/src/.umi-production/plugin-initialState/@@initialState';
import { useQiankunStateForSlave as model_4 } from 'E:/jenkins/jenkins_home/workspace/prod_ragflow_web/apps/web/src/app';

export const models = {
model_1: { namespace: 'qiankunState', model: model_1 },
model_2: { namespace: 'system', model: model_2 },
model_3: { namespace: '@@initialState', model: model_3 },
model_4: { namespace: '@@qiankunStateForSlave', model: model_4 },
} as const
